module.exports = __webpack_public_path__ + "static/media/anatomia1.b79d5372.png";